import { render, staticRenderFns } from "./layout-body.vue?vue&type=template&id=1875803f&scoped=true"
import script from "./layout-body.vue?vue&type=script&lang=js"
export * from "./layout-body.vue?vue&type=script&lang=js"
import style0 from "./layout-body.vue?vue&type=style&index=0&id=1875803f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875803f",
  null
  
)

export default component.exports